import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ListSelectorData } from './interfaces';



@Component({
  selector: 'app-list-selector',
  templateUrl: './list-selector.page.html',
  styleUrls: ['./list-selector.page.scss'],
})
export class ListSelectorPage implements OnInit {
  @Input() listings:ListSelectorData
  constructor(
    private modalCtrl:ModalController
  ) { 

  }

  async ngOnInit() {
 
  }

  selectListing(listing){
    this.back(listing);
  }


  async back(listing:any = null) {
    await this.modalCtrl.dismiss(listing);
  }
}
